import "css/ValueDisplay.css";

export default function ValueDisplay({ text, value }) {
  return (
    <div className="valueDisplayContainer">
      <div className="valueDisplayText">{text}</div>
      <div className="value">{value}</div>
    </div>
  );
}
